import { connect } from 'react-redux';
import { getIsAppRebrandActive } from '../../selectors/app';
import { CheckoutState } from '../../state';

const mapStateToProps = (
    state: CheckoutState,
): Partial<{ isAppRebrandActive: boolean }> => ({
    isAppRebrandActive: getIsAppRebrandActive(state),
});

export type ConnectedProps = ReturnType<typeof mapStateToProps>;

const connectLoadingPage = connect(mapStateToProps);

export default connectLoadingPage;
